import React from "react";

const PrivacyCard = ({ type, content, textSize = "text-xs" }) => {
  const renderContent = () => {
    switch (type) {
      case "paragraph":
        return <p className={`${textSize} font-normal font-poppins text-[#000000] text-left mb-2 sm:mb-3 md:mb-4 leading-loose`}>{content}</p>;

      case "titleBlue":
        return (
          <h2 className={`${textSize} font-semibold text-[20px] font-poppins text-[#2F327D] text-left mb-2 sm:mb-3 md:mb-4`}>
            {content}
          </h2>
        );

      case "titleBlack":
        return (
          <h2 className={`${textSize} font-normal font-poppins text-[#000000] text-left mb-2 sm:mb-3 md:mb-4`}>
            {content}
          </h2>
        );

      case "list":
        return (
          <ul className="list-disc pl-5 sm:pl-8 md:pl-10 mb-2 sm:mb-3 md:mb-4 space-y-1 sm:space-y-2">
            {content.map((item, index) => (
              <li key={index} className={`text-left ${textSize} font-normal font-poppins text-[#000000] pb-1`}>
                {item}
              </li>
            ))}
          </ul>
        );

      case "numberedList":
        return (
          <ol className="list-decimal pl-5 sm:pl-6 mb-2 sm:mb-3 md:mb-4 space-y-1 sm:space-y-2">
            {content.map((item, index) => (
              <li key={index} className={`text-left ${textSize} font-normal font-poppins text-[#000000] pb-1`}>
                {item}
              </li>
            ))}
          </ol>
        );

      case "html":
        return (
          <div 
            className={`privacy-html-content ${textSize} font-normal font-poppins text-[#000000] text-left mb-2 sm:mb-3 md:mb-4 leading-loose`}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        );

      default:
        return null;
    }
  };

  return <div className="mb-3 sm:mb-4 md:mb-5">{renderContent()}</div>;
};

export default PrivacyCard;